var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnemicButton',{staticClass:"px-5 tab-button mr-1",class:{ selected: _vm.isSelected },attrs:{"tile":""},on:{"click":function($event){return _vm.$emit('tab-clicked', _vm.tab)}}},[_vm._v(" "+_vm._s(_vm.tab)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }